<!-- eslint-disable max-len -->
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Annonce"
        transform="translate(-165.000000, -523.000000)"
        :fill="color"
        fill-rule="nonzero"
      >
        <g id="Pièces" transform="translate(165.000000, 521.000000)">
          <g id="Bed" transform="translate(0.000000, 2.000000)">
            <path
              d="M3.02325535,0.195943182 C2.63795637,0.19598083 2.32561945,0.501219175 2.32558093,0.877761364 L2.32558093,4.96867045 L1.62790651,4.96867045 C0.738115814,4.96867045 -5.81395349e-07,5.69001136 -5.81395349e-07,6.55957955 L-5.81395349e-07,12.0141364 C3.79427246e-05,12.3906786 0.312374854,12.6959169 0.697673837,12.6959545 L0.697673837,14.2868636 C0.697712361,14.6634059 1.01004934,14.9686442 1.39534837,14.9686818 L3.25581349,14.9686818 C3.64111247,14.9686442 3.95344938,14.6634058 3.95348791,14.2868636 L3.95348791,12.6959545 L16.0465109,12.6959545 L16.0465109,14.2868636 C16.0465495,14.6634058 16.3588864,14.9686442 16.7441853,14.9686818 L18.6046516,14.9686818 C18.9899506,14.9686442 19.3022875,14.6634058 19.302326,14.2868636 L19.302326,12.6959545 C19.687625,12.6959169 19.9999619,12.3906786 20.0000005,12.0141364 L20.0000005,6.55957955 C20.0000005,5.69001136 19.2618842,4.96867045 18.3720935,4.96867045 L17.6744179,4.96867045 L17.6744179,0.877761364 C17.6743794,0.501219175 17.3620425,0.19598083 16.9767435,0.195943182 L3.02325512,0.195943182 L3.02325535,0.195943182 Z M3.72092953,1.55957955 L16.2790691,1.55957955 L16.2790691,4.96867045 L15.8139528,4.96867045 L15.8139528,3.60503409 C15.8139143,3.2284919 15.5015774,2.92325356 15.1162784,2.92321591 L11.3953481,2.92321591 C11.0100492,2.92325356 10.6977122,3.2284919 10.6976737,3.60503409 L10.6976737,4.96867045 L9.30232488,4.96867045 L9.30232488,3.60503409 C9.30228636,3.2284919 8.98994945,2.92325356 8.60465047,2.92321591 L4.88372023,2.92321591 C4.49842125,2.92325356 4.18608434,3.2284919 4.18604581,3.60503409 L4.18604581,4.96867045 L3.72092953,4.96867045 L3.72092953,1.55957955 L3.72092953,1.55957955 Z M5.58139488,4.28685227 L7.90697628,4.28685227 L7.90697628,4.96867045 L5.58139488,4.96867045 L5.58139488,4.28685227 L5.58139488,4.28685227 Z M12.0930226,4.28685227 L14.418604,4.28685227 L14.418604,4.96867045 L12.0930226,4.96867045 L12.0930226,4.28685227 L12.0930226,4.28685227 Z M1.62790628,6.33230682 L18.3720935,6.33230682 C18.5130051,6.33230682 18.6046516,6.42187045 18.6046516,6.55957955 L18.6046516,8.1505 L1.39534814,8.1505 L1.39534814,6.55957955 C1.39534814,6.42187045 1.48699465,6.33230682 1.62790628,6.33230682 Z M1.39534814,9.51413636 L18.6046516,9.51413636 L18.6046516,11.3323182 L1.39534814,11.3323182 L1.39534814,9.51413636 Z M2.09302256,12.6959545 L2.55813884,12.6959545 L2.55813884,13.6050455 L2.09302256,13.6050455 L2.09302256,12.6959545 Z M17.4418598,12.6959545 L17.906976,12.6959545 L17.906976,13.6050455 L17.4418598,13.6050455 L17.4418598,12.6959545 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import props from "@/components/Icons/props";

export default {
  props: { ...props },
  name: "Bed",
};
</script>
